var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"component__glossary-extractor--translation-detail"},[_c('p',{staticClass:"mb-6",domProps:{"innerHTML":_vm._s(_vm.formatedSrc)}}),(!!_vm.detail && _vm.detail.translation)?[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formatedTarget)}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }